export enum InterestCalculationType {
    Linear = 1,
    Zaronia = 2,
}